import get from 'lodash.get';
import set from 'lodash.set';

/*
 This map determine what values in the redux store will be persisted so that the 
 values will survive page reloads. StorageMiddleware assumes a key-value storage
 where data can be persisted.
 The pathKeyMap key represent the path in the redux store to persist. 
 The pathKeyMap value is the name of the key used in the key-value storage.
 */
const pathKeyMap = {
  'app.proactiveTriggered': 'proactiveTriggered',
  'configuration.cohortId': 'cohortId',
  'session.welcomeMessage': 'welcomeMessage',
  'ui.chatLastViewedAt': 'chatLastViewedAt',
  'ui.isMinimized': 'isMinimized',
  'ui.minimizedAt': 'minimizedAt',
  user: 'user',
};

const storageMiddleware = storage => {
  return store => next => action => {
    const prevState = store.getState();
    const result = next(action);
    const nextState = store.getState();

    Object.keys(pathKeyMap).forEach(path => {
      const prevVal = get(prevState, path);
      const nextVal = get(nextState, path);
      const key = pathKeyMap[path];

      if (prevVal != nextVal) {
        if (typeof nextVal === 'undefined' || nextVal === null) {
          storage.delete(key);
        } else {
          storage.save(key, nextVal);
        }
      }
    });

    return result;
  };
};

export const getStoredInitialState = storage => {
  let state = {};
  for (const path in pathKeyMap) {
    const key = pathKeyMap[path];
    // Note Path should not be part of argument, have it here temporary until old cookieMiddleware is phased out
    const value = storage.getInitialState(key, path);
    if (typeof value !== 'undefined' && value !== null) {
      set(state, path, value);
    }
  }

  return state;
};

export default storageMiddleware;
